<template>
    <zm-button
      size='large'
      round
      type="primary"
      @click="handleClick"
    >
      {{ ctaName }}
    </zm-button>
</template>

<script>
import setupMixin from "@/views/success/mixin/set-up";
import { mapGetters } from 'vuex';
import { plansof } from '@/utils/chain';
import { planTypes } from '@/common/constants';
import { translateToEn } from '@/plugins/i18n';
import { navigateParentWindowTo } from '@/utils/modal-utils.js'
import { sendGAbizInfo } from '@/views/checkout/utils'

export default {
  mixins: [setupMixin],
  props: {
    showExplore: Boolean,
  },
  computed: {
    ...mapGetters(['boughtPlans']),
    isSetUpZPCTA() {
      return plansof(this.boughtPlans).type(planTypes.ZOOM_ONE_BUNDLE, planTypes.ZONE_PRO_PLUS,planTypes.ZOOM_PHONE,planTypes.ZOOM_PHONE$ZPA,planTypes.ZOOM_PHONE$ZPI).has();
    },
    ctaName() {
      if (this.companySetupZoomOneName) {
        return this.companySetupZoomOneName;
      } else if (this.isSetUpZPCTA) {
        return this.$t('billing.success.get_started');
      } else {
        return this.$t('billing.success.confirmation.view_my_plan');
      }
    },
    ctaEnName() {
      if (this.companySetupZoomOneName) {
        return this.companySetupZoomOneEnName;
      } else if (this.isSetUpZPCTA) {
        return translateToEn('billing.success.get_started');
      } else {
        return translateToEn('billing.success.confirmation.view_my_plan');
      }
    },
  },
  methods: {
    goBilling() {
      window.location.href = '/billing';
    },
    handleClick() {
      sendGAbizInfo('purchase confirmation', this.ctaEnName?.toLowerCase?.())
      if (this.companySetupZoomOneName) {
        this.goCompanySetup();
      } else if (this.isSetUpZPCTA) {
        const targetURL = '/pbx/page/telephone/new?p=new';
        if (this.$context.is.modal) {
          navigateParentWindowTo(targetURL);
        } else {
          window.location.href = targetURL;
        }
      } else {
        const targetURL = '/billing';
        if (this.$context.is.modal) {
          navigateParentWindowTo(targetURL);
        } else {
          window.location.href = targetURL;
        }
      }
    }
  }
}
</script>

<style lang="scss">

</style>
